import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type { Response } from '@/types/response'

export async function getResponse(id: string): Promise<Response> {
  return await makeGetRequest(`${ApiBase}/response/${id}`)
}

export async function getPublicResponse(
  code: string,
  params?: { packetMessageCode?: string | null }
): Promise<Response> {
  return await makeGetRequest(
    ApiBase +
      `/response/${code}/public` +
      (params?.packetMessageCode
        ? `?packet_message_code=${params.packetMessageCode}`
        : '')
  )
}
